import { render, staticRenderFns } from "./TrendingPublishings.vue?vue&type=template&id=6c680bd2&scoped=true"
import script from "./TrendingPublishings.vue?vue&type=script&lang=js"
export * from "./TrendingPublishings.vue?vue&type=script&lang=js"
import style0 from "./TrendingPublishings.vue?vue&type=style&index=0&id=6c680bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c680bd2",
  null
  
)

export default component.exports